module.exports = __webpack_public_path__ + "assets/8e0338c1100399135065d97c0d8cd0a0.png";